import React, { useMemo } from "react";
import "./CategoriesContainer.css";
import { useSelector } from "react-redux";
import CategoryCard from "../CategoryCard/CategoryCard";
import PerfectScrollbar from "react-perfect-scrollbar";

const CategoriesContainer = (props) => {
  // const categories = useSelector(state => state.masterCategories);
  const configFilters = useSelector((state) => state.config.filters);
  const filters = useSelector((state) => state.filters);
  const activeFilters = useSelector((state) => state.activeFilters);
  const searchWord = useSelector((state) => state.searchWord);
  // const display = useSelector(state => state.config.display);
  const placeholders = useSelector((state) => state.config.placeholders);
  const autocomplete = useSelector((state) => state.config.autocomplete);
  const triggers = useSelector((state) => state.config.triggers);
  const raccomandationsCategories = useSelector(
    (state) => state.config.triggers.raccomandationsCategories
  );
  const { setSubCategory } = props;
  // const isAutocompleteOpen = useSelector(state => state.isAutocompleteOpen);
  const isMobile = useSelector((state) => state.isMobile);
  const categoryTiles = useSelector(
    (state) => state.config.triggers.categoryTiles
  );

  var minChars = useMemo(
    () =>
      isMobile ? autocomplete.minChars.mobile : autocomplete.minChars.desktop,
    [isMobile, autocomplete]
  );
  var raccomandationsCategoriesResponsive = useMemo(
    () =>
      isMobile
        ? raccomandationsCategories.mobile
        : raccomandationsCategories.desktop,
    [isMobile, raccomandationsCategories]
  );
  var categoryTilesResponsive = useMemo(
    () => (isMobile ? categoryTiles.mobile : categoryTiles.desktop),
    [isMobile, categoryTiles]
  );

  const categoryKey = useMemo(() => {
    var valueToReturn = "";
    Object.keys(configFilters).forEach((filter) => {
      if (configFilters[filter].isCategory) valueToReturn = filter;
    });
    return valueToReturn;
  }, [configFilters]);

  const categories = useMemo(() => {
    var categories = filters.filter((filter) => filter.title === categoryKey);
    return categories.length > 0
      ? Object.keys(categories[0].values).map((value) => ({ value: value }))
      : [];
  }, [categoryKey, filters]);

  var dividedCategories = useMemo(() => {
    var categoriesToReturn = [];
    var dividedIndex = -1;
    categoriesToReturn[0] = [];
    categoriesToReturn[1] = [];
    categoryTilesResponsive.forEach((element, index) => {
      // if(index%3===0) {dividedIndex++;categoriesToReturn[dividedIndex]=[]}
      // categoriesToReturn[dividedIndex].push(element);
      if (isMobile) {
        dividedIndex = index % 2 === 0 ? 0 : 1;
        categoriesToReturn[dividedIndex].push(element);
      } else {
        if (index % 3 === 0) {
          dividedIndex++;
          categoriesToReturn[dividedIndex] = [];
        }
        categoriesToReturn[dividedIndex].push(element);
      }
    });
    return categoriesToReturn;
  }, [categoryTilesResponsive, isMobile]);
  return (
    <div
      className={
        "categories-container " +
        (raccomandationsCategoriesResponsive.length > 0
          ? "with-categories "
          : "") +
        (triggers.raccomandationsProducts.length > 0 ? "with-products " : "") +
        (activeFilters.length > 0 || searchWord.length >= minChars
          ? "is-searching"
          : "")
      }
    >
      {/* <div className="search-label "> {isMobile?placeholders.mainCategories:placeholders.labelTiles} </div> */}
      <div className="search-label "> {placeholders.mainCategories} </div>
      {activeFilters.length > 0 || searchWord.length >= minChars ? (
        categories.length > 1 ? (
          !isMobile ? (
            categories
              .filter((item, index) => index < triggers.icebreaker.number)
              .map((el, index) => (
                <CategoryCard
                  value={el}
                  key={"category_" + index}
                  setSubCategory={setSubCategory}
                />
              ))
          ) : (
            <PerfectScrollbar className="horizontal-categories">
              {categories
                .filter((item, index) => index < triggers.icebreaker.number)
                .map((el, index) => (
                  <CategoryCard value={el} key={"category_" + index} setSubCategory={setSubCategory}/>
                ))}
            </PerfectScrollbar>
          )
        ) : null
      ) : (
        <div className="rows-container">
          {categoryTilesResponsive.length > 0
            ? dividedCategories.map((element, index) => (
                <div className="row" key={"row_category_" + index}>
                  {element.map((subElement, subIndex) => (
                    <CategoryCard
                      value={subElement}
                      key={"category_" + subIndex}
                      isShowcaseTile={true}
                      
                    />
                  ))}
                </div>
              ))
            : null}
        </div>
      )}
      <div className="categories-separator"></div>
    </div>
  );
};

export default CategoriesContainer;
